var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-page"},[_c('dl',[_vm._m(0),_c('dd',[_c('CustomAlert')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dt',[_c('h2',[_vm._v("Alert")])])}]

export { render, staticRenderFns }